module.exports = __webpack_public_path__ + "static/contact-53557081fccf917afdbea01fb7e92ef9.jpg";